export default __webpack_public_path__ + "static/media/ic_malta.3a4074a5.svg";